module.exports = __webpack_public_path__ + "static/media/bussula_background.00842ba6.svg";